// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import "../design/skeleton-preview.css";

const tasks = [
  ["01", "Маркировка", "Нанести код и проверить его читаемость"],
  ["02", "Этикетирование", "Автоматизировать нанесение этикетки"],
  ["03", "Упаковка", "Подготовить продукт к отгрузке"],
  ["04", "Контроль", "Найти дефект до выхода продукции"],
  ["05", "Интеграция", "Связать линию, данные и сервис"],
];

const process = [
  ["A", "Разбираем задачу", "Продукт, упаковка, скорость, среда и критерии результата."],
  ["B", "Проверяем решение", "Тестируем технологию и конфигурацию на реальных образцах."],
  ["C", "Запускаем линию", "Интегрируем оборудование, обучаем команду и фиксируем параметры."],
  ["D", "Поддерживаем", "Диагностика, обслуживание, расходные материалы и инженерная связь."],
];

function Mark() {
  return <span className="ds-mark" aria-hidden="true"><i/><i/><i/></span>;
}

export function DesignSkeletonPage() {
  return <main className="design-skeleton">
    <header className="ds-header">
      <Link className="ds-brand" to="/"><b>A</b><span><strong>ANLEXX</strong><small>industrial engineering</small></span></Link>
      <nav aria-label="Навигация макета">
        <a href="#tasks">Решения</a><a href="#system">Система</a><a href="#engineering">Инженерный центр</a><a href="#service">Сервис</a>
      </nav>
      <div className="ds-header-end"><span>RU</span><a href="#contact">Обсудить проект</a></div>
    </header>

    <section className="ds-hero">
      <div className="ds-hero-grid ds-wrap">
        <div className="ds-index"><Mark/><span>01 / ГЛАВНАЯ</span></div>
        <div className="ds-hero-copy">
          <p className="ds-kicker">Инженерные системы для производства</p>
          <h1>Линия работает.<br/><em>Мы отвечаем</em><br/>за результат.</h1>
          <p className="ds-lead">Проектируем маркировку, этикетирование, упаковку и контроль качества как одну управляемую производственную систему.</p>
          <div className="ds-actions"><a className="ds-button ds-button-dark" href="#contact">Показать задачу <span>↗</span></a><a className="ds-text-link" href="#tasks">Выбрать направление <span>↓</span></a></div>
        </div>
        <aside className="ds-hero-aside">
          <span className="ds-aside-label">Инженерный маршрут</span>
          <ol><li><b>01</b> Диагностика</li><li><b>02</b> Проектирование</li><li><b>03</b> Запуск</li><li><b>04</b> Сервис</li></ol>
          <div className="ds-live"><i/> Инженерная связь 24/7</div>
        </aside>
      </div>
      <div className="ds-signal"><span>MARKING</span><span>LABELING</span><span>PACKAGING</span><span>VISION</span><span>SOFTWARE</span><span>SERVICE</span></div>
    </section>

    <section className="ds-section ds-tasks" id="tasks">
      <div className="ds-wrap">
        <div className="ds-section-head"><div><span>02 / ЗАДАЧА</span><h2>Начинаем не с оборудования.<br/>Начинаем с производства.</h2></div><p>Выберите, что должно происходить на линии. Дальше мы построим понятный инженерный маршрут.</p></div>
        <div className="ds-task-list">{tasks.map(([n,title,text]) => <a href="#contact" key={n}><span>{n}</span><div><h3>{title}</h3><p>{text}</p></div><b>↗</b></a>)}</div>
      </div>
    </section>

    <section className="ds-system" id="system">
      <div className="ds-wrap ds-system-grid">
        <div className="ds-system-title"><span>03 / ЕДИНЫЙ КОНТУР</span><h2>Одна задача.<br/>Одна система.<br/>Одна ответственность.</h2></div>
        <div className="ds-system-map">
          <div className="ds-map-core"><span>ANLEXX</span><b>Инженерный<br/>контур</b></div>
          <div className="ds-map-node node-a"><span>01</span><b>Оборудование</b></div>
          <div className="ds-map-node node-b"><span>02</span><b>Механика линии</b></div>
          <div className="ds-map-node node-c"><span>03</span><b>Данные и ПО</b></div>
          <div className="ds-map-node node-d"><span>04</span><b>Сервис</b></div>
        </div>
      </div>
    </section>

    <section className="ds-section ds-engineering" id="engineering">
      <div className="ds-wrap">
        <div className="ds-section-head"><div><span>04 / ИНЖЕНЕРНЫЙ ЦЕНТР</span><h2>От вопроса на линии<br/>до стабильной работы.</h2></div><p>Каждый этап объясняет клиенту, что именно делает ANLEXX и какой результат должен быть получен.</p></div>
        <div className="ds-process">{process.map(([n,title,text]) => <article key={n}><span>{n}</span><div><h3>{title}</h3><p>{text}</p></div></article>)}</div>
      </div>
    </section>

    <section className="ds-service" id="service">
      <div className="ds-wrap ds-service-grid">
        <div><span className="ds-service-code">05 / СЕРВИС</span><h2>Производство<br/>не должно ждать.</h2></div>
        <div className="ds-service-copy"><p>Инженер принимает обращение, уточняет симптомы, проводит первичную диагностику и согласовывает следующий шаг.</p><div className="ds-hotline"><span>Инженер 24/7</span><a href="tel:+998973447857">+998 97 344 78 57</a></div></div>
      </div>
    </section>

    <section className="ds-contact" id="contact">
      <div className="ds-wrap ds-contact-grid"><div><span>06 / НОВЫЙ ПРОЕКТ</span><h2>Покажите<br/>задачу.</h2></div><div><p>Достаточно описать продукт, скорость линии и желаемый результат. Инженер подскажет, с какого шага начать.</p><a className="ds-button ds-button-light" href="mailto:info@anlexx.uz">Написать в ANLEXX <span>↗</span></a><small>info@anlexx.uz · +998 93 566 79 55 · +998 99 820 65 53</small></div></div>
    </section>

    <footer className="ds-footer"><div className="ds-wrap"><strong>ANLEXX</strong><span>Скелет новой дизайн-системы · фоновые материалы будут добавлены после утверждения структуры</span><Link to="/">Вернуться на текущий сайт</Link></div></footer>
  </main>;
}
